/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-else-return */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-alert */
import { useState, useEffect, memo, useMemo } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Button } from "components/core";
import { WelcomeInformation, FormSignIn, FormSignUp } from "components/Login";
import {
  sendCodeSMS,
  verifyCodeSMS,
  initializedRecaptcha,
  fetchBackend,
} from "helpers";
import { useWindowSize } from "hooks";
import { useGlobalContext } from "context/GlobalContext";
import { OTPInput } from "components/OPTInputComponent/Index";
import Countdown from "react-countdown";
import iconHeader from "assets/images/auth/icons/header.svg";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CancelIcon from "@material-ui/icons/Cancel";
import styled from "./Login.module.css";

export const Login = () => {
  const [currentStep, setStep] = useState(0);
  const [currentPhone, setNumber] = useState("");
  const [isLoading, setLoading] = useState(false);
  const { width } = useWindowSize();
  const gContext = useGlobalContext();
  const isMobile = width <= 425;

  const getCurrentError = (code) => {
    let message;
    switch (code) {
      case "auth/invalid-verification-code":
        message =
          "El código de verificación por SMS utilizado para crear la credencial de autenticación del teléfono no es válido. Vuelva a enviar el código de verificación por SMS y asegúrese de utilizar el código de verificación proporcionado por el usuario";
        break;
      case "auth/app-deleted":
        message = "Se lanza si se borró la instancia de FirebaseApp.";
        break;
      case "auth/app-not-authorized":
        message =
          "Se lanza si la aplicación identificada por el dominio donde está alojada no está autorizada para usar Firebase Authentication con la clave de API proporcionada. Revise la configuración de su clave en la consola de API de Google.";
        break;
      case "auth/argument-error":
        message =
          "Se lanza si se llama a un método con argumentos incorrectos.";
        break;
      case "auth/invalid-api-key":
        message =
          "Se lanza si la clave de API proporcionada no es válida. Verifique que lo haya copiado correctamente desde Firebase Console.";
        break;
      case "auth/invalid-user-token":
        message =
          "Se lanza si la credencial del usuario ya no es válida. El usuario debe iniciar sesión nuevamente.";
        break;
      case "auth/invalid-tenant-id":
        message =
          "Se lanza si la identificación de inquilino proporcionada no es válida.";
        break;
      case "auth/network-request-failed":
        message =
          "Se lanza si se ha producido un error de red (como tiempo de espera, conexión interrumpida o host inaccesible).";
        break;
      case "auth/operation-not-allowed":
        message =
          "Se lanza si no ha habilitado el proveedor en Firebase Console. Vaya a Firebase Console para su proyecto, en la sección Auth y en la pestaña Método de inicio de sesión y configure el proveedor.";
        break;
      case "auth/requires-recent-login":
        message =
          "Se lanza si la hora del último inicio de sesión del usuario no alcanza el umbral de seguridad. Usa firebase.User.reauthenticateWithCredential para resolver. Esto no se aplica si el usuario es anónimo.";
        break;
      case "auth/too-many-requests":
        message =
          "Se lanza si las solicitudes se bloquean desde un dispositivo debido a una actividad inusual. Intentarlo de nuevo después de un poco de retraso se desbloquearía.";
        break;
      case "auth/unauthorized-domain":
        message =
          "Se lanza si el dominio de la aplicación no está autorizado para las operaciones de OAuth para su proyecto de Firebase. Edite la lista de dominios autorizados desde Firebase console.";
        break;
      case "auth/user-disabled":
        message =
          "Se lanza si un administrador ha desactivado la cuenta de usuario. Las cuentas se pueden habilitar o deshabilitar en Firebase Console, la sección Auth y la subsección Usuarios.";
        break;
      case "auth/user-token-expired":
        message =
          "Se lanza si la credencial del usuario ha caducado. Esto también podría producirse si se ha eliminado un usuario. Solicitar al usuario que inicie sesión nuevamente debería resolver esto en cualquier caso.";
        break;
      case "auth/web-storage-unsupported":
        message =
          "Se lanza si el navegador no admite el almacenamiento web o si el usuario los desactiva.";
        break;
      case "auth/captcha-check-failed":
        message =
          "Se lanza si el token de respuesta reCAPTCHA no era válido, venció o si se llamó a este método desde un dominio no incluido en la lista blanca.";
        break;
      case "auth/invalid-phone-number":
        message =
          "Se lanza si el número de teléfono tiene un formato no válido.";
        break;
      case "auth/missing-phone-number":
        message = "Se lanza si falta el número de teléfono.";
        break;
      case "auth/quota-exceeded":
        message =
          "Se lanza si se superó la cuota de SMS para el proyecto de Firebase.";
        break;
      case "auth/maximum-second-factor-count-exceeded":
        message =
          "Se lanza si se ha superado el número máximo permitido de segundos factores en un usuario.";
        break;
      case "auth/second-factor-already-in-use":
        message =
          "Se lanza si el segundo factor ya está inscrito en esta cuenta.";
        break;
      case "auth / unsupported-first-factor":
        message =
          "Se lanza si no se admite el primer factor que se usa para iniciar sesión.";
        break;
      case "auth/unverified-email":
        message =
          "Lanzado si el correo electrónico de la cuenta no está verificado.";
        break;
      default:
        message = "Hubo un error al intentar verificar su número";
        break;
    }
    return message;
  };

  const nextStep = async (value) => {
    switch (currentStep) {
      case 0:
        setNumber(value);
        setStep((s) => s + 1);
        // sendSMS(value);
        break;
      case 1:
        setStep((s) => s + 1);
        // handleVerifyCodeSMS(value);
        break;
      case 2:
        // gContext.handleSetUser(value);
        break;
      default:
        console.log("Hubo un error", value);
        break;
    }
  };

  const prevStep = () => {
    setStep((s) => s - 1);
  };

  const sendStepLogin = () => {
    setStep(5);
  };

  const sendStepRegister = () => {
    setStep(0);
  };

  const onReset = () => {
    setStep(0);
  };

  useEffect(async () => {
    await initializedRecaptcha();
  }, []);

  return (
    <Grid
      fluid
      className={styled.bgContent}
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in-back"
      data-aos-delay="50"
      data-aos-offset="0"
    >
      <Row className="m0">
        <Grid fluid={isMobile} className="pl2 pr0">
          <Row center="xs" middle="xs" className="min-vh-100">
            <div
              className={styled.blurredBox}
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <div className={styled.userLoginBox}>
                <div id="sign-in-button" className="dn"></div>
                <Step1
                  currentStep={currentStep}
                  setNumber={nextStep}
                  sendStepLogin={sendStepLogin}
                  setLoading={setLoading}
                  isLoading={isLoading}
                />
                <Step2
                  currentStep={currentStep}
                  currentPhone={currentPhone}
                  nextStep={nextStep}
                  prevStep={prevStep}
                  setLoading={setLoading}
                  isLoading={isLoading}
                  gContext={gContext}
                  getCurrentError={getCurrentError}
                />
                <Step3
                  currentStep={currentStep}
                  currentPhone={currentPhone}
                  sendStepLogin={sendStepLogin}
                  nextStep={nextStep}
                  onReset={onReset}
                />
                <Step5
                  currentStep={currentStep}
                  currentPhone={currentPhone}
                  sendStepLogin={sendStepLogin}
                  sendStepRegister={sendStepRegister}
                  nextStep={nextStep}
                  onReset={onReset}
                />
              </div>
            </div>
          </Row>
        </Grid>
      </Row>
    </Grid>
  );
};

const Step1 = ({
  currentStep,
  setNumber,
  sendStepLogin,
  setLoading,
  isLoading,
}) => {
  if (currentStep !== 0) return null;

  return (
    <>
      <img src={iconHeader} alt="icon-header" className={styled.logo} />
      <WelcomeInformation />
      <FormSignIn
        setNumber={setNumber}
        sendStepLogin={sendStepLogin}
        setLoading={setLoading}
        isLoading={isLoading}
      />
    </>
  );
};

const Step2 = memo(
  ({
    currentStep,
    currentPhone,
    prevStep,
    nextStep,
    isLoading,
    gContext,
    getCurrentError,
    setLoading,
  }) => {
    const [isLoadingSMS, setLoadingSMS] = useState(false);
    const [isLoadingWhatsapp, setLoadingWhatsapp] = useState(false);
    const [isWaitingRequest, setWaitingRequest] = useState(false);
    const [isSendCode, setSendCode] = useState(false);
    const [metaCode, setMetaCode] = useState(null);
    const [currentDate, setDate] = useState(Date.now() + 120000);
    // const [isRepeatSendCode, setRepeatSendCode] = useState(false);
    // const [isCharge, setCharge] = useState(false);
    const [type, setType] = useState("");
    const [currentCode, setCode] = useState("");
    const [error, setError] = useState("");

    const handleVerifyCodeSMS = async (code) => {
      setLoading(true);
      const { error: errorRequest, response } = await verifyCodeSMS(code);
      setLoading(false);

      if (!errorRequest) {
        // setStep((s) => s + 1);
        nextStep();
        gContext.toggleAlert({
          message: "Número de celular validado con exito",
        });
      } else {
        gContext.toggleAlert({
          message: getCurrentError(response?.code || response?.i.code),
          type: "error",
        });
      }
    };

    const handleVerifyWhatsappCode = async () => {
      setLoading(true);
      const { error: errorRequest, response } = await fetchBackend({
        data: metaCode,
        method: "post",
        url: `client/verification`,
      });
      setLoading(true);
      if (!errorRequest) {
        nextStep();
        gContext.toggleAlert({
          message: "Número de celular validado con exito",
        });
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al enviar la petición al servidor, verifica tu conexión a internet",
          type: "error",
        });
      }
    };

    const onSubmit = (e) => {
      e.preventDefault();
      if (currentCode.toString().length === 6) {
        setError(false);

        if (type === "sms") {
          // nextStep(currentCode);
          handleVerifyCodeSMS(currentCode);
        } else {
          if (currentCode.toString() === metaCode?.code.toString()) {
            handleVerifyWhatsappCode();
          } else {
            gContext.toggleAlert({
              message:
                "El código introducido no es valido, verifique de favor.",
              type: "error",
            });
          }
        }
      } else {
        setError(true);
      }
    };

    const sendWhatsappCode = async (isWaiting = true) => {
      setLoadingWhatsapp(true);
      setSendCode(true);
      setType("whatsapp");
      setWaitingRequest(isWaiting);
      setDate(Date.now() + 120000);
      const { error: errorRequest, response } = await fetchBackend({
        url: `client/verification/+52${currentPhone}`,
      });
      setLoadingWhatsapp(false);
      if (!errorRequest) {
        setMetaCode(response);
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al enviar la petición al servidor, verifica tu conexión a internet",
          type: "error",
        });
      }
    };

    const sendSMS = async (isWaiting = true) => {
      setLoadingSMS(true);
      setSendCode(true);
      setType("sms");
      setWaitingRequest(isWaiting);
      setDate(Date.now() + 120000);
      const { error: errorRequest, response } = await sendCodeSMS(
        `+52${currentPhone}`
      );
      setLoadingSMS(false);
      // setRepeatSendCode(true);
      if (!errorRequest) {
        // setStep((s) => s + 1);
      } else {
        gContext.toggleAlert({
          message: getCurrentError(response?.code),
          type: "error",
        });
      }
    };

    const renderer = ({ minutes, seconds, completed }) => {
      if (completed) {
        return (
          <Col md={12} className="p0">
            <Button
              htmlType="submit"
              color="default"
              size="large"
              className="w-100"
              loading={type === "sms" ? isLoadingSMS : isLoadingWhatsapp}
              onClick={
                type === "sms"
                  ? () => sendSMS(false)
                  : () => sendWhatsappCode(false)
              }
            >
              Volver a enviar código
            </Button>
          </Col>
        );
      } else {
        return (
          <>
            <Col md={12} className="p0">
              <Button
                htmlType="submit"
                color="default"
                size="large"
                className="w-100"
                disabled={true}
              >
                Vuelva a intentar en: {minutes}:{seconds}
              </Button>
            </Col>
          </>
        );
      }
    };

    const RendererComponent = useMemo(() => renderer, [
      type,
      sendSMS,
      sendWhatsappCode,
    ]);
    console.log(isWaitingRequest);

    if (currentStep !== 1) return null;

    return (
      <>
        <Row className="ma3">
          <ArrowBackIcon onClick={prevStep} className="pointer" />
        </Row>
        <Row className="pa3">
          <Col md={12}>
            <p className="tl-ns black">
              Ingresa los 4 dígitos del código de verificación que enviamos al
              teléfono: +52&nbsp;
              {currentPhone}
            </p>
          </Col>
          <Col md={12}>
            <OTPInput
              autoFocus
              isNumberInput
              length={6}
              className={styled.otpContainer}
              inputClassName={styled.otpInput}
              onChangeOTP={setCode}
              error={
                error &&
                currentCode.toString().length !== 6 &&
                `Falta ingresar ${Math.abs(currentCode.length - 6)} digitos`
              }
            />
          </Col>
          {isSendCode && (
            <Col md={12}>
              <Countdown date={currentDate} renderer={RendererComponent} />
            </Col>
          )}
          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="secondary"
              size="large"
              className="w-100"
              loading={isLoadingWhatsapp}
              disabled={isWaitingRequest || isLoadingWhatsapp || isLoadingSMS}
              onClick={() => sendWhatsappCode(true)}
            >
              Verificar con WhatsApp
            </Button>
          </Col>
          <Col md={12} className="mt2">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              loading={isLoadingSMS}
              disabled={isWaitingRequest || isLoadingWhatsapp || isLoadingSMS}
              onClick={() => sendSMS(true)}
            >
              Verificar con SMS
            </Button>
          </Col>

          <Col md={12} className="mt3">
            <Button
              htmlType="submit"
              color="primary"
              size="large"
              className="w-100"
              loading={isLoading}
              disabled={!isSendCode}
              onClick={onSubmit}
            >
              Continuar
            </Button>
          </Col>
        </Row>
      </>
    );
  }
);

const Step3 = ({
  currentStep,
  currentPhone,
  onReset,
  nextStep,
  sendStepLogin,
}) => {
  if (currentStep !== 2) return null;
  return (
    <>
      <Row end="xs" className="ma3">
        <CancelIcon onClick={onReset} className="pointer" />
      </Row>
      <Row className="ph3">
        <Col md={12}>
          <h1 className="ma0">Registrarse</h1>
        </Col>
      </Row>
      <FormSignUp
        currentPhone={currentPhone}
        nextStep={nextStep}
        sendStepLogin={sendStepLogin}
      />
    </>
  );
};

const Step5 = ({
  currentStep,
  nextStep,
  onReset,
  sendStepLogin,
  sendStepRegister,
  currentPhone,
}) => {
  if (currentStep !== 5) return null;
  return (
    <>
      <Row end="xs" className="ma3">
        <CancelIcon onClick={onReset} className="pointer" />
      </Row>
      <Row className="ph3">
        <Col md={12}>
          <h1 className="ma0">Iniciar sesión</h1>
        </Col>
      </Row>
      <FormSignUp
        isLogin
        currentPhone={currentPhone}
        nextStep={nextStep}
        sendStepLogin={sendStepLogin}
        sendStepRegister={sendStepRegister}
      />
    </>
  );
};
